const createObjectWithSameKeys = (
  source,
  initialValueForEveryProperty = undefined
) => {
  const result = {};
  Object.keys(source).forEach((_) => {
    result[_] = initialValueForEveryProperty;
  });
  return result;
};

export default createObjectWithSameKeys;
